import React from "react";
import logo from '../../assets/logo.png';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { ROLES } from '../../constants';

const SIDEBAR_COLLAPSED_KEY = 'pp-cms-sidebar-collapsed';
const SIDEBAR_SCROLL_KEY = 'pp-cms-sidebar-scroll-top';
let lastSidebarScrollTop = 0;

const PRIMARY_NAV_ITEMS = [
    {
        to: '/',
        label: 'Chat Monitoring',
        icon: 'fa-desktop',
        title: 'Chat Monitoring',
        exact: true,
        matchPaths: ['/']
    },
    {
        to: '/classsetup',
        label: 'Class Setup',
        icon: 'fa-users',
        title: 'Class Setup',
        matchPaths: ['/classsetup', '/addclassdetails', '/editclassdetails']
    },
    {
        to: '/chathistory',
        label: 'Chat / Game History',
        icon: 'fa-comments',
        title: 'Chat / Game History',
        matchPaths: ['/chathistory']
    }
];

const ADMIN_NAV_ITEMS = [
    {
        to: '/adminsetup',
        label: 'Admin User Setup',
        icon: 'fa-male',
        title: 'Admin User Setup',
        matchPaths: ['/adminsetup']
    },
    {
        to: '/blockedwords',
        label: 'Chat Blocked Words',
        icon: 'fa-ban',
        title: 'Chat Blocked Words',
        matchPaths: ['/blockedwords']
    },
    {
        to: '/gamemaintenance',
        label: 'Game Maintenance',
        icon: 'fa-gamepad',
        title: 'Game Maintenance',
        matchPaths: ['/gamemaintenance', '/addquestion', '/questionslist', '/editquestion']
    },
    {
        to: '/mediaupload',
        label: 'Media Upload',
        icon: 'fa-cloud-upload',
        title: 'Media Upload',
        matchPaths: ['/mediaupload']
    },
    {
        to: '/popupmessages',
        label: 'Pop Up Messages',
        icon: 'fa-comments-o',
        title: 'Pop Up Messages',
        matchPaths: ['/popupmessages']
    },
    {
        to: '/admessages',
        label: 'Ad Messages',
        icon: 'fa-commenting-o',
        title: 'Ad Messages',
        matchPaths: ['/admessages']
    },
    {
        to: '/favoriteactivties',
        label: 'Profile Settings',
        icon: 'fa-cogs',
        title: 'Profile Settings',
        matchPaths: ['/favoriteactivties']
    },
    {
        to: '/fontupload',
        label: 'Font Upload',
        icon: 'fa-fonticons',
        title: 'Font Upload',
        matchPaths: ['/fontupload']
    },
    {
        to: '/fontsize',
        label: 'Font Settings',
        icon: 'fa-font',
        title: 'Font Settings',
        matchPaths: ['/fontsize']
    }
];

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.sidebarRef = React.createRef();
        this.restoreTimers = [];
        let user = null;
        try {
            const stored = localStorage.getItem('user');
            user = stored ? JSON.parse(stored) : null;
        } catch {
            user = null;
        }
        const sidebarCollapsed = localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true';
        this.state = {
            showConfirmation: false,
            user,
            sidebarCollapsed
        };
        this.syncSidebarCollapsedToBody(sidebarCollapsed);
    }

    componentDidMount() {
        this.queueSidebarRestore();
    }

    componentDidUpdate(prevProps, prevState) {
        const routeChanged = prevProps.location.pathname !== this.props.location.pathname;
        const sidebarOpened = prevState.sidebarCollapsed && !this.state.sidebarCollapsed;

        if (routeChanged || sidebarOpened) {
            this.queueSidebarRestore();
        }
    }

    componentWillUnmount() {
        this.saveSidebarScroll();
        this.clearRestoreTimers();
    }

    syncSidebarCollapsedToBody = (collapsed) => {
        if (typeof document === 'undefined') return;
        if (collapsed) {
            document.body.classList.add('sidebar-collapsed');
        } else {
            document.body.classList.remove('sidebar-collapsed');
        }
    };

    getSidebarStorage = () => {
        if (typeof window === 'undefined') return null;
        try {
            return window.sessionStorage;
        } catch {
            return null;
        }
    };

    clearRestoreTimers = () => {
        this.restoreTimers.forEach((timerId) => clearTimeout(timerId));
        this.restoreTimers = [];
    };

    getSavedSidebarScroll = () => {
        const storage = this.getSidebarStorage();
        let savedScrollTop = lastSidebarScrollTop;

        if (!storage) return savedScrollTop;

        const storedValue = parseInt(storage.getItem(SIDEBAR_SCROLL_KEY) || String(lastSidebarScrollTop), 10);
        if (!Number.isNaN(storedValue)) {
            savedScrollTop = storedValue;
        }

        return savedScrollTop;
    };

    saveSidebarScroll = () => {
        const sidebar = this.sidebarRef.current;
        if (!sidebar) return;

        lastSidebarScrollTop = sidebar.scrollTop;

        const storage = this.getSidebarStorage();
        if (!storage) return;

        try {
            storage.setItem(SIDEBAR_SCROLL_KEY, String(lastSidebarScrollTop));
        } catch (e) {}
    };

    restoreSidebarScroll = () => {
        const sidebar = this.sidebarRef.current;
        if (!sidebar || this.state.sidebarCollapsed) return;

        sidebar.scrollTop = this.getSavedSidebarScroll();
    };

    queueSidebarRestore = () => {
        if (typeof window === 'undefined' || this.state.sidebarCollapsed) return;

        this.clearRestoreTimers();
        [0, 100, 250, 500].forEach((delay) => {
            const timerId = window.setTimeout(() => {
                this.restoreSidebarScroll();
            }, delay);
            this.restoreTimers.push(timerId);
        });
    };

    toggleSidebar = () => {
        this.setState(
            (prev) => {
                const next = !prev.sidebarCollapsed;
                try {
                    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(next));
                } catch (e) {}
                return { sidebarCollapsed: next };
            },
            () => this.syncSidebarCollapsedToBody(this.state.sidebarCollapsed)
        );
    };

    handleShow = (event) => {
        event.preventDefault();
        this.setState({ showConfirmation: true });
    };

    handleClose = () => {
        this.setState({ showConfirmation: false });
    };

    isPathActive = (matchPaths = [], exact = false) => {
        const pathname = this.props.location?.pathname || '';

        return matchPaths.some((path) => {
            if (path === '/') {
                return pathname === '/';
            }

            if (exact) {
                return pathname === path;
            }

            return pathname === path || pathname.startsWith(`${path}/`);
        });
    };

    getActiveNavItem = () => {
        const navItems = [...PRIMARY_NAV_ITEMS, ...ADMIN_NAV_ITEMS];
        return navItems.find((item) => this.isPathActive(item.matchPaths, item.exact)) || null;
    };

    getHeaderTitle = () => {
        return this.getActiveNavItem()?.title || '';
    };

    renderNavItem = (item) => {
        const isActive = this.isPathActive(item.matchPaths, item.exact);

        return (
            <li key={item.to} className={isActive ? 'active' : ''}>
                <NavLink
                    exact={item.exact}
                    className={isActive ? 'active' : ''}
                    to={item.to}
                    aria-current={isActive ? 'page' : undefined}
                >
                    <i className={`fa ${item.icon}`} aria-hidden /> {item.label}
                </NavLink>
            </li>
        );
    };

    render() {
        const { user } = this.state;
        const { sidebarCollapsed } = this.state;
        const branding = this.props.branding;
        const logoSrc = branding?.cmsLogoUrl || logo;
        const logoAlt = branding?.CMS_LOGO_ALT || 'Safety Village';
        const primaryNavItems = PRIMARY_NAV_ITEMS;
        const adminNavItems = ADMIN_NAV_ITEMS;

        return (
            <>
                <nav className="mnb top-nav navbar navbar-default navbar-fixed-top">
                    <div className="container-fluid">
                        <div className="navbar-header">
                            <button
                                type="button"
                                className="sidebar-toggle navbar-toggle"
                                onClick={this.toggleSidebar}
                                aria-label={sidebarCollapsed ? 'Open menu' : 'Close menu'}
                            >
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                            </button>
                            <span className="navbar-brand text-white">{this.getHeaderTitle()}</span>
                        </div>
                        <div id="navbar" className="navbar-collapse collapse">
                            <ul className="nav navbar-nav navbar-right">
                                {user && <li><a href="#">Hi {user.data.FirstName} {user.data.LastName}!</a></li>}
                                <li><a href="#" onClick={this.handleShow}>Logout</a></li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <div
                    className="msb"
                    id="msb"
                    aria-hidden={sidebarCollapsed}
                    ref={this.sidebarRef}
                    onScroll={this.saveSidebarScroll}
                >
                    <nav className="navbar navbar-default sidebar-nav" role="navigation">
                        <div className="sidebar-header">
                            <div className="brand-wrapper">
                                <div className="brand-name-wrapper">
                                    <a className="navbar-brand" href="#">
                                        <img
                                            src={logoSrc}
                                            className="navbar-logo"
                                            alt={logoAlt}
                                            onLoad={this.queueSidebarRestore}
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div
                            className="side-menu-container"
                            onMouseDownCapture={this.saveSidebarScroll}
                            onClickCapture={this.saveSidebarScroll}
                        >
                            <ul className="nav navbar-nav side-menu-nav">
                                <li><span className="side-menu-title">Class Admin Screens</span></li>
                                {primaryNavItems.map(this.renderNavItem)}
                                {user?.data?.UserRole === ROLES.ADMIN && (
                                    <>
                                        <li><span className="side-menu-title">CMS Main Screens</span></li>
                                        {adminNavItems.map(this.renderNavItem)}
                                    </>
                                )}
                            </ul>
                        </div>
                    </nav>
                </div>

                <Modal className='logoutModal' animation={false} show={this.state.showConfirmation} onHide={this.handleClose}>
                    <Modal.Body>Are you sure you want to Logout?</Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-default" variant="secondary" onClick={this.handleClose}>
                            No, Stay In
                        </button>
                        <a className="btn btn-primary pull-right" href="/login">
                            Yes, Logout
                        </a>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        branding: state.organization?.branding,
    };
}

export default withRouter(connect(mapStateToProps)(Header));
